export default "<div class=\"no-data\">\n    <img src=\"../../assets/images/no-data.png\">\n    <span>No matching data found!</span>\n</div>"